import { render } from "./DigitalLabels.vue?vue&type=template&id=49a013c6&scoped=true"
import script from "./DigitalLabels.vue?vue&type=script&lang=js"
export * from "./DigitalLabels.vue?vue&type=script&lang=js"

import "./DigitalLabels.vue?vue&type=style&index=0&id=49a013c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a013c6"]])

export default __exports__